import React, { useEffect, useMemo, useState } from 'react'

const Layout7 = ({ data }) => {

    const { video, products = [], title, brand, infoText, canvas } = data;

    const [currentImgIndex, setCurrentImgIndex] = useState(0);

    const filteredProducts = useMemo(
        () => (products || []).filter(p => p && p.trim() !== ""),
        [products]
    );

    useEffect(() => {
        setCurrentImgIndex(0);
    }, [filteredProducts.length]);

    useEffect(() => {
        if (!filteredProducts.length) return;

        const interval = setInterval(() => {

            setTimeout(() => {
                setCurrentImgIndex((prev) =>
                    prev === filteredProducts.length - 1 ? 0 : prev + 1
                );
            }, 1000);
        }, 6000);

        return () => clearInterval(interval);
    }, [filteredProducts.length]);


    useEffect(() => {
        filteredProducts.forEach((src) => {
            const img = new Image();
            img.src = src;
        });
    }, [filteredProducts]);


    return (
        <div className="relative w-full h-full  flex overflow-hidden">

            <div className="w-[40%] h-full">
                <div className="relative w-full h-full">
                    {filteredProducts.length > 0 ? (
                        <img
                            key={`product-${currentImgIndex}`}
                            src={filteredProducts[currentImgIndex]}
                            alt={`product-${currentImgIndex + 1}`}
                            className="h-full w-full object-fill animate-[slideFromLeftProduct7_1s_cubic-bezier(0.22,1,0.36,1)]"
                        />
                    ) : (
                        <div className="w-32 h-32 bg-gray-300 animate-pulse rounded" />
                    )}
                </div>
            </div>

            <div className='w-[60%] p-5'>

                <div className="w-full overflow-hidden h-[55%]">
                    {video?.url ? (
                        <video
                            src={video.url}
                            autoPlay
                            muted
                            loop
                            playsInline
                            className="w-full h-full object-fill"
                        />
                    ) : (
                        <div className="flex items-center justify-center h-full">
                            Upload Video
                        </div>
                    )}
                </div>

                <div className="h-[45%] flex items-center justify-between gap-2 py-8 px-3">
                    <div className='max-w-[430px]'>
                        <h1 className="text-6xl font-semibold leading-tight break-words" style={{ color: canvas.textColor }}>
                            {title}
                        </h1>
                    </div>

                    <div className="flex flex-col items-center justify-center">
                        {brand?.qrCodeUrl && (
                            <img
                                src={brand.qrCodeUrl}
                                alt="QR"
                                className="w-36 h-36 mb-2 bg-white"
                            />
                        )}
                        <div className="text-xl text-center font-medium mt-2" style={{ color: canvas.textColor }}>{infoText}</div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default Layout7